import PropTypes from 'prop-types';
import React from 'react';

import { Box } from '../../grid';
import { Icon } from '../../icons';
import { P } from '../../typography';

const RestaurantDetail = ({ iconName, iconFill, detailText, detailTextColor }) => (
  <>
    <Box>
      <Icon name={iconName} fill={iconFill} mr="0.5rem" position="relative" top="-2px" />
    </Box>
    <P fontWeight="normal" color={detailTextColor}>
      {detailText}
    </P>
  </>
);

RestaurantDetail.propTypes = {
  iconName: PropTypes.string.isRequired,
  iconFill: PropTypes.string,
  detailText: PropTypes.string.isRequired,
  detailTextColor: PropTypes.string,
};

RestaurantDetail.defaultProps = {
  iconFill: 'black',
  detailTextColor: 'black',
};

export { RestaurantDetail };
